import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
localStorage.setItem("app_id","c624113e-0f56-404a-9cc8-441c481d58f5")
createApp(App).use(router).mount('#app')
